import PropTypes from 'prop-types';
import React from 'react';
import cuid from 'cuid';

import { get } from 'ctm-util-functions';

import { Text } from '../text/text';

import styles from './opening_hours.css';

/**
 * Displays the opening hours for call centres
 * Note: various verticals get hours from the backend.
 * @param {Object} props React props
 * @returns {OpeningHours} a OpeningHours component
 */
const OpeningHours = (props) => {
    const variant = get(props, 'visualProps.variant');

    /**
     * Builds the labels as in Mon - Fri: 8am - 4pm
     * @returns {Array} A div for each set of hours.
     */
    const getChildren = () => {
        return get(props, 'contentProps.values', []).map((obj) => {
            return (
                <div key={cuid()} className={styles.nowrap}>
                    <Text color="brand_base_120" size="small">{obj.key}</Text>
                    <Text color="brand_base_60" size="small">{obj.value}</Text>
                </div>
            );
        });
    };

    return (
        <div className={styles[variant]}>
            {getChildren()}
        </div>
    );
};

OpeningHours.propTypes = {
    visualProps: PropTypes.shape({
        variant: PropTypes.string
    }),
    contentProps: PropTypes.shape({
        values: PropTypes.array.isRequired
    }).isRequired
};

export { OpeningHours };
